import type ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import { getExtendedPropertyUri } from 'owa-service/lib/ServiceRequestUtils';

export const EventPollDurationExtendedProperty: ExtendedPropertyUri = getExtendedPropertyUri(
    'CEAFA50E-74C8-4BD9-A882-2087F1433729',
    'EventPollDuration',
    'Integer'
);
